import { useRef, useState } from 'react';

const MarqueeSelectWrapper = ({ children, onSelect }) => {
    const containerRef = useRef();
    const [marquee, setMarquee] = useState(null);
    const marqueeRef = useRef(null);

    const handleMouseDown = (e) => {
        if (e.button !== 0) return;

        e.preventDefault();
        e.stopPropagation();

        const containerRect = containerRef.current.getBoundingClientRect();
        const startX = e.clientX - containerRect.left;
        const startY = e.clientY - containerRect.top;

        const initialMarquee = { x: startX, y: startY, width: 0, height: 0 };
        setMarquee(initialMarquee);
        marqueeRef.current = initialMarquee;

        const mouseMoveHandler = (moveEvent) => {
            const currentX = moveEvent.clientX - containerRect.left;
            const currentY = moveEvent.clientY - containerRect.top;

            const x = Math.min(currentX, startX);
            const y = Math.min(currentY, startY);
            const width = Math.abs(currentX - startX);
            const height = Math.abs(currentY - startY);

            const newMarquee = { x, y, width, height };
            setMarquee(newMarquee);
            marqueeRef.current = newMarquee;
        };

        const mouseUpHandler = () => {
            if (marqueeRef.current && marqueeRef.current.width > 5 && marqueeRef.current.height > 5) {
                const currentMarquee = marqueeRef.current;

                const selectedItems = [];
                const items = containerRef.current.querySelectorAll('.selectable-item');

                items.forEach((item) => {
                    const rect = item.getBoundingClientRect();
                    const containerRect = containerRef.current.getBoundingClientRect();

                    const itemLeft = rect.left - containerRect.left;
                    const itemTop = rect.top - containerRect.top;
                    const itemRight = rect.right - containerRect.left;
                    const itemBottom = rect.bottom - containerRect.top;

                    const inX = itemRight >= currentMarquee.x && itemLeft <= currentMarquee.x + currentMarquee.width;
                    const inY = itemBottom >= currentMarquee.y && itemTop <= currentMarquee.y + currentMarquee.height;

                    if (inX && inY) {
                        selectedItems.push(item.dataset.id);
                    }
                });

                onSelect(selectedItems);
            }

            setMarquee(null);
            marqueeRef.current = null;

            document.removeEventListener('mousemove', mouseMoveHandler);
            document.removeEventListener('mouseup', mouseUpHandler);
        };

        document.addEventListener('mousemove', mouseMoveHandler);
        document.addEventListener('mouseup', mouseUpHandler);
    };

    return (
        <div
            ref={containerRef}
            onMouseDown={handleMouseDown}
            className="marquee-container relative w-screen left-1/2 -translate-x-1/2"
            style={{ position: 'relative', userSelect: 'none' }}
        >
            <div className="container max-w-large">{children}</div>

            {marquee && (
                <div
                    className="marquee-box absolute border border-blue-500 bg-blue-300/20 pointer-events-none z-10"
                    style={{
                        left: `${marquee.x}px`,
                        top: `${marquee.y}px`,
                        width: `${marquee.width}px`,
                        height: `${marquee.height}px`,
                    }}
                />
            )}
        </div>
    );
};

export default MarqueeSelectWrapper;
